import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ChatApp from './components/ChatApp';
import Footer from './components/Footer';
import { ThemeProvider } from './components/theme-provider';
import ContactForm from './components/ContactForm';

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-brand-dark text-white">
        <Navbar />
        <HeroSection />
        <section id="about">
          <AboutSection />
        </section>
        <section id="case-studies">
          <CaseStudiesSection />
        </section>
        <section id="chat">
          <ChatApp />
        </section>
        <section id="contact">
          <ContactForm />
        </section>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;